import {
  stripeIdSubscriptionFirstYearly,
  stripeIdSubscriptionSecondYearly,
  stripeIdSubscriptionThirdYearly,
} from "@/constants/payment";

export const isYearlySubscription = (stripeSubscriptionId: string): boolean => {
  return (
    stripeSubscriptionId === stripeIdSubscriptionFirstYearly ||
    stripeSubscriptionId === stripeIdSubscriptionSecondYearly ||
    stripeSubscriptionId === stripeIdSubscriptionThirdYearly
  );
};
